var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAddPhoto(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M50 7.5V17.5",
    stroke: "#A3A3AC",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M45 12.5H55",
    stroke: "#A3A3AC",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M35 12.5H12.5C9.7375 12.5 7.5 14.7375 7.5 17.5V47.5C7.5 50.2625 9.7375 52.5 12.5 52.5H45C47.7625 52.5 50 50.2625 50 47.5V27.5",
    stroke: "#A3A3AC",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.4175 36.1685L21.1775 30.2035C22.05 28.821 23.9925 28.6335 25.1125 29.8235L27.8 32.6785L30.6175 26.691C31.485 24.846 34.08 24.761 35.0675 26.546L40.4525 36.291C41.3725 37.9585 40.165 40.001 38.2625 40.001H19.5325C17.5625 40.001 16.3675 37.8335 17.4175 36.1685Z",
    fill: "#DDDEFD",
    stroke: "#A3A3AC",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddPhoto);
export default __webpack_public_path__ + "static/media/add-photo.333b41e2.svg";
export { ForwardRef as ReactComponent };